import { useMemo } from "react"
import { createDateFormatter, createDateShortFormatter } from "@/lib/format"
import { useHousehold } from "./use-household"

export function useDateFormat() {
  const { data } = useHousehold()
  const locale = data?.household?.locale ?? "en-IN"
  return useMemo(() => createDateFormatter(locale), [locale])
}

export function useDateShortFormat() {
  const { data } = useHousehold()
  const locale = data?.household?.locale ?? "en-IN"
  return useMemo(() => createDateShortFormatter(locale), [locale])
}
